import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

import { useAppDispatch } from '@/hooks/redux-helpers';

import { closeAlert, validateAction } from '@/store/actions/alert.actions';

import { TAlertKey } from '@/store/types/alert.types';

export function useAlert(alertKey: TAlertKey) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const alertClasses = `max-w-lg shadow-100`;

  const handleAlertClose = useCallback(() => {
    dispatch(closeAlert(alertKey));
  }, [dispatch, alertKey]);

  const handleAlertValidate = useCallback(() => {
    dispatch(validateAction(alertKey));
  }, [dispatch, alertKey]);

  return {
    dispatch,
    navigate,
    t,
    handleAlertClose,
    handleAlertValidate,
    alertClasses,
  };
}
